import { api } from "@/lib/api/api";
import { args } from "@/lib/args/args";
import { path } from "@/lib/path/path";
import { out } from "@/lib/output/out";
import { printSession } from "@/lib/session/print-session";
import { runSessionControlAction } from "@/commands/command/run-session-control-action";
import { detail } from "@/commands/detail/detail";
import { CONTROL_PATHS } from "@/commands/sessions/sessions-constants";
import type { ApiOutputs } from "@/lib/api/api-outputs";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

export async function runSessionOperation(
  parsed: ParsedArgs,
  action: string,
  asJson: boolean,
): Promise<void> {
  // Only kill consumes --reason; the other operations must reject it.
  args.expect(parsed, {
    positional: 2,
    ...(action === "kill" ? { flags: ["reason"] } : {}),
  });

  const sessionId = args.required(parsed, 1, "sessionId");

  if (action === "get") {
    const session = detail(
      await api(path`/sessions/${sessionId}`),
      "GET /sessions/{id}",
    );
    if (asJson) {
      out.json(session);
      return;
    }
    printSession(session);
    return;
  }

  // Avoid inherited keys such as `toString` becoming control paths.
  if (Object.hasOwn(CONTROL_PATHS, action)) {
    await runSessionControlAction(parsed, action, sessionId, asJson);
    return;
  }

  if (action === "checks") {
    out.json(
      await api<ApiOutputs["sessions"]["runChecks"]>(
        path`/sessions/${sessionId}/checks`,
        { method: "POST", body: {} },
      ),
    );
    return;
  }

  if (action === "pr") {
    out.json(
      await api<ApiOutputs["sessions"]["prChecks"]>(
        path`/sessions/${sessionId}/pr-checks`,
      ),
    );
    return;
  }

  out.json(
    await api<ApiOutputs["sessions"]["verification"]>(
      path`/sessions/${sessionId}/verification`,
    ),
  );
}
